import React from 'react';

const SvgUpload = props => (
  <svg width={17} height={16} {...props}>
    <path
      d="M16.513 8.07c.27 0 .487.217.487.48v4.35c0 1.708-1.414 3.1-3.157 3.1H3.157C1.417 16 0 14.611 0 12.9V8.478A.48.48 0 0 1 .487 8a.48.48 0 0 1 .487.478V12.9c0 1.18.978 2.143 2.183 2.143h10.686c1.202 0 2.183-.96 2.183-2.143V8.55a.48.48 0 0 1 .487-.48zM8.167.145a.46.46 0 0 1 .67 0L11.86 3.23a.492.492 0 0 1 0 .687.467.467 0 0 1-.673 0l-2.21-2.26v9.856c0 .27-.211.486-.475.486a.479.479 0 0 1-.476-.486V1.66l-2.213 2.26a.467.467 0 0 1-.673 0 .492.492 0 0 1 0-.688L8.167.144z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgUpload;
